// React Libraries
import { useEffect } from 'react';
import { useLocation, ScrollRestoration } from 'react-router-dom';

// Function that resetting the scroll position to the top of the page when the user navigates to a new page in the application using the react-router-dom library
// Why => This is done to ensure that the user is always taken to the top of the page when they navigate to a new page
export default function ScrollToTop() {
    // Getting the current location of the user
    const location = useLocation();

    // Resetting the scroll position to the top of the page when the user navigates to a new page
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [location.pathname]);

    return <ScrollRestoration />;
}

// ScrollRestoration hook is used to reset the scroll position to the top of the page when the user navigates to a new page in the application as well as to reset the scroll position when the user navigates back to the previous page
